import api from './api';

/**
 * Programme Stations (lot 037) : aide à la saisie et signaux.
 *
 * Chemins et formes de réponse : `backend/app/api/v1/station_insights.py`.
 * L'application d'un recalibrage porte un identifiant choisi ici (clé
 * d'idempotence) : un renvoi après coupure rend le même résultat.
 */

const unwrap = (response) => response?.data?.data ?? response?.data;

const nouvelId = () =>
  typeof crypto !== 'undefined' && crypto.randomUUID
    ? crypto.randomUUID()
    : `${Date.now().toString(16)}-${Math.random().toString(16).slice(2)}`;

export const insightsApi = {
  /** Signaux d'une station sur 30 jours : `{ signals, signal_count, level }`. */
  async station(stationId) {
    return unwrap(await api.get(`/stations/${stationId}/insights`));
  },

  /** Une ligne par station, pour le tableau réseau : `[{ station_id, signal_count, level, counts }]`. */
  async network() {
    return unwrap(await api.get('/station-insights')) || [];
  },

  /** Proposition de correction du barème d'une cuve. */
  async recalibration(stationId, tankId) {
    return unwrap(await api.get(`/stations/${stationId}/tanks/${tankId}/recalibration`));
  },

  /** Applique la proposition vue (administrateur) ; `empreinte` vient de la proposition. */
  async appliquerRecalibration(stationId, tankId, empreinte, id = nouvelId()) {
    return unwrap(
      await api.post(`/stations/${stationId}/tanks/${tankId}/recalibration/apply`, { id, fingerprint: empreinte }),
    );
  },

  /**
   * Index proposé d'après la photo d'un compteur. Soit `fichier` (la photo),
   * soit `documentId` (photo déjà envoyée). Rien n'est enregistré : le relevé
   * confirmé porte ensuite `source: 'PHOTO'` et `photo_document_id`.
   */
  async lirePhoto(stationId, { nozzleId, kind = 'CLOSING', fichier, documentId }) {
    const corps = new FormData();
    corps.append('nozzle_id', nozzleId);
    corps.append('kind', kind);
    if (documentId) corps.append('document_id', documentId);
    if (fichier) corps.append('file', fichier);
    return unwrap(
      await api.post(`/stations/${stationId}/readings/photo`, corps, {
        headers: { 'Content-Type': 'multipart/form-data', 'Idempotency-Key': nouvelId() },
      }),
    );
  },
};

export default insightsApi;
